import dayjs from "dayjs";
import {
  b2bAmountPaidInCents,
  b2bRemainingAmountInCents,
  BonificoB2BContractDTO,
} from "../../ProductService/BonificoOrder/BonificoOrderDTO.ts";

function formatEuros(amountInCents: number): string {
  return `€${(amountInCents / 100).toFixed(2)}`;
}

function DetailRow({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <span className="font-medium text-gray-700">{label}:</span>
      <p className="text-gray-600">{value}</p>
    </div>
  );
}

export function B2BContractDetails({
  contract,
}: {
  contract: BonificoB2BContractDTO;
}) {
  const courseGrants = contract.courseGrants ?? [];
  return (
    <div className="flex flex-col gap-4 text-sm">
      <div className="grid grid-cols-2 gap-3">
        <DetailRow
          label="Data del contratto"
          value={dayjs(contract.contractDateUtc).format("DD/MM/YYYY")}
        />
        <DetailRow
          label="Importo del contratto"
          value={formatEuros(contract.contractAmountInCents.amount)}
        />
        <DetailRow
          label="Già pagato"
          value={formatEuros(b2bAmountPaidInCents(contract))}
        />
        <DetailRow
          label="Resta da pagare"
          value={formatEuros(b2bRemainingAmountInCents(contract))}
        />
      </div>
      <h4 className="font-semibold text-gray-900">Pagamenti</h4>
      {contract.payments.length > 0 ? (
        <table className="w-full text-left">
          <thead className="text-xs uppercase text-gray-500">
            <tr>
              <th className="py-1">Data valuta</th>
              <th className="py-1">Importo</th>
              <th className="py-1">Registrato il</th>
            </tr>
          </thead>
          <tbody>
            {contract.payments.map((payment) => (
              <tr key={payment.paymentId} className="border-t border-gray-100">
                <td className="py-1.5">
                  {dayjs(payment.valueDateUtc).format("DD/MM/YYYY")}
                </td>
                <td className="py-1.5 font-medium text-gray-900">
                  {formatEuros(payment.amountInCents.amount)}
                </td>
                <td className="py-1.5 text-gray-500">
                  {dayjs(payment.registeredAtUtc).format("DD/MM/YYYY HH:mm")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-gray-500">Nessun pagamento registrato.</p>
      )}
      <h4 className="font-semibold text-gray-900">Corsi erogati</h4>
      {courseGrants.length > 0 ? (
        <table className="w-full text-left">
          <thead className="text-xs uppercase text-gray-500">
            <tr>
              <th className="py-1">Partecipante</th>
              <th className="py-1">Corso</th>
              <th className="py-1">Erogato il</th>
            </tr>
          </thead>
          <tbody>
            {courseGrants.map((grant) => (
              <tr key={grant.grantId} className="border-t border-gray-100">
                <td className="py-1.5">
                  <div className="font-medium text-gray-900">
                    {grant.beneficiary.firstName} {grant.beneficiary.lastName}
                  </div>
                  <div className="text-xs text-gray-500">
                    {grant.beneficiary.email}
                  </div>
                </td>
                <td className="py-1.5">
                  {grant.productSnapshot.variantProductName}
                </td>
                <td className="py-1.5 text-gray-500">
                  {dayjs(grant.grantedAtUtc).format("DD/MM/YYYY HH:mm")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-gray-500">Nessun corso erogato.</p>
      )}
    </div>
  );
}
